import { SlotsEnum } from "../enums/SlotsEnum";

export default class DateSlotComparisonDto {
  public leaveDate!: string;
  public slot!: SlotsEnum;
}
